/** Guide CTA callback keys. */
export const PUSH_NOTIFICATIONS_GUIDE_CALLBACK_KEY = 'enable-push-notifications';
